import React, { useEffect, useState, useContext, Fragment } from "react";
import Layout from "components/sales/layout/layout";
import TableSection from "components/sales/tableSection/tableSection";
import localization from "assets/localization/localization";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import { Link } from "react-router-dom";

const PlanScheduleList = ({
  filePlanUploadListing,
  filePlanUploadData = [],
}) => {
  const headers = [
    "Requested CSV",
    "Response CSV",
    "Success Count",
    "Created By",
    "Status",
    "Created at"
  ];
  const [listData, setListData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  // const [filterData, setFilterData] = useState(null);
  // const [isRoleId, setIsRoleId] = useState(null);
  const { baseUrl } = useContext(BaseUrl);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await filePlanUploadListing(null, 1);
      setIsLoading(false);
    })();
  }, []);

  useEffect(() => {
    const tableData = [
      "requested_csv",
      "response_csv",
      "success_count",
      "created_by_name",
      "status",
      "created_at"
    ];

    if (
      filePlanUploadData !== undefined &&
      filePlanUploadData.data !== undefined &&
      filePlanUploadData.data.length > 0
    ) {
      const data = filePlanUploadData.data.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) =>
            key === "requested_csv"
              ? {
                  [key]: (
                    <a href={element["requested_csv"]} target="_blank">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="30"
                        height="30"
                        fill="currentColor"
                        class="bi bi-file-earmark-arrow-down-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0M9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1m-1 4v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 11.293V7.5a.5.5 0 0 1 1 0" />
                      </svg>
                    </a>
                  ),
                }
              : key === "response_csv"
              ? {
                  [key]: (
                    <a href={element["response_csv"]} target="_blank">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="30"
                        height="30"
                        fill="currentColor"
                        class="bi bi-file-earmark-arrow-down-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0M9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1m-1 4v3.793l1.146-1.147a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 .708-.708L7.5 11.293V7.5a.5.5 0 0 1 1 0" />
                      </svg>
                    </a>
                  ),
                }
                : key === "status"
                ? {
                    [key]: element[key] === 1 ? "Completed" : element[key],
                    }
              : { [key]: element[key] }
          )
        )
      );
      data && setListData(data);
      setPageCount(
        Math.ceil(filePlanUploadData.total / filePlanUploadData.per_page)
      );
    }
  }, [filePlanUploadData]);

  const onPageChange = async (val) => {
    setIsLoading(true);
    await filePlanUploadListing(null, val.selected + 1);
    setIsLoading(false);
  };

  const headerBtns = () => {
    return (
      <Fragment>
        <Link
          to={{
            pathname: `${baseUrl}/brand-activation/plan-schedule`,
          }}
          className="btn btn-primary d-md-inline-block"
        >
          {localization.planScheduleUpload}
        </Link>
      </Fragment>
    );
  };

  return (
    <Layout
      title={localization.uploadResponseList}
      Buttons={headerBtns}
      isLoading={isLoading}
    >
      <TableSection
        data={listData}
        isId={false}
        headers={headers}
        detailList={filePlanUploadData && filePlanUploadData.data}
        pageCount={pageCount}
        srNo={filePlanUploadData?.from}
        onPageChange={onPageChange}
        currentPage={localStorage.getItem("page")}
      />
    </Layout>
  );
};

export default PlanScheduleList;
